<template>
  <BaseListCard
    title="Localities & Tax Parcels"
    :parentId="propertyId"
    :parentTitle="'Property'"
    :entityType="'property'"
    :options="{}"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :entitySort="entitySort"
    :deleteEntity="deleteEntity"
    :deleteDisabled="deleteDisabled"
    :emptyEntity="emptyEntity"
    :viewBorderClass="(entity) => entity.primary ? 'border-success' : ''"
    ref="baseCard"
    >
    <template v-slot:addForm="{ newEntity, options, stopAdding, entityCreated }">
      <LocalityForm
         :initialPropertyLocality="newEntity"
         :taxParcelSort="taxParcelSort"
         @closeForm="stopAdding">
      </LocalityForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <LocalityForm
        :initialPropertyLocality="entity"
        :taxParcelSort="taxParcelSort"
        @closeForm="stopEditing">
      </LocalityForm>
    </template>
    <template v-slot:entityDetails="{ entity }">
      <div class="row mb-3">
        <div class="col-md-5">
          <div class="list-header">
            Locality Name
          </div>
          <div class="list-details">
            {{getLocalityName(entity.localityId)}}
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-md-12">
          <div class="list-header">
            Tax Parcel(s)
          </div>
          <div v-if="!entity.taxParcels || entity.taxParcels.length === 0" class="list-details">
            None
          </div>
          <div class="list-group">
            <div v-for="parcel in sortedParcels(entity.taxParcels)"
              :key="parcel.id"
              class="list-group-item">
              <div class="form-row">
                <div class="list-header col-3">
                  Tax Parcel ID
                </div>
                <div class="list-details col-3">
                  {{parcel.parcelId ? parcel.parcelId : 'None'}}
                </div>
                <div class="list-header col-3">
                  Tax Parcel Acres
                </div>
                <div class="list-details col-3">
                  {{parcel.acres | acresFormat}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:cardHeader="{ entity }">
      <div v-if="entity.primary" class="card-header font-weight-bold text-success">Primary</div>
    </template>
    <template v-slot:additionalActions="{ entity }">
      <a v-if="!entity.primary"
        class="form-action-text text-secondary px-0 mr-2"
        @click="makePrimary(entity)">
        Make Primary
      </a>
    </template>
  </BaseListCard>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import api from '@/api';
import BaseListCard from '../common/BaseListCard.vue';
import CollapseParent from '@/mixins/CollapseParent';
import LocalityForm from './LocalityForm.vue';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'LocalitiesCard',
  components: {
    BaseListCard,
    LocalityForm,
  },
  mixins: [CollapseParent],
  props: [
    'propertyId',
  ],
  computed: {
    ...mapState(EntityModules.LOCALITY.namespace, {
      entities: state => state.entities,
      entitiesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.LOCALITIES.namespace, {
      getLocalityName: 'getName',
    }),
  },
  created() {
    this.$store.dispatch(`${LookupModules.LOCALITIES.namespace}/fetchOptions`,
      LookupModules.LOCALITIES.url);
  },
  methods: {
    entitySort(a, b) {
      const primarySort = b.primary - a.primary;
      if (primarySort) {
        return primarySort;
      }
      return this.getLocalityName(a.localityId)
        .localeCompare(this.getLocalityName(b.localityId));
    },
    sortedParcels(taxParcels) {
      return taxParcels.slice().sort((a, b) => (this.taxParcelSort(a, b)));
    },
    taxParcelSort(a, b) {
      const acresSort = b.acres - a.acres;
      if (acresSort) {
        return acresSort;
      }
      return a.parcelId.localeCompare(b.parcelId);
    },
    emptyEntity(propertyId) {
      return {
        localityId: '',
        taxParcels: [],
        primary: false,
        propertyId,
      };
    },
    makePrimary(entity) {
      api.post(`/property/updateprimarylocality/${entity.id}`)
        .then(() => {
          const existingPrimary = this.entities.find(e => e.primary);
          if (existingPrimary) existingPrimary.primary = false;
          const newPrimary = entity;
          newPrimary.primary = true;
          this.$store.dispatch(
            `${EntityModules.LOCALITY.namespace}/updateStoredEntity`, {
              entity: newPrimary,
            },
          );
          this.$store.dispatch(
            `${EntityModules.LOCALITY.namespace}/updateStoredEntity`, {
              entity: existingPrimary,
            },
          );
        });
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${EntityModules.LOCALITY.namespace}/deleteEntity`, {
          entityType: EntityModules.LOCALITY.namespace,
          entity,
        },
      );
    },
    deleteDisabled: entity => entity.primary,
  },
};
</script>
